import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la'
export default (props) => {
  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="en"
      market="latino"
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/formula1-b.jpg?w=2048&ch=width&auto=format,compress"
      title="Live Grand Prix Races in Spanish"
      subtitle="Stream them from any device"
      networkSet="entertainmentLatino"
      noteLink="/la/formula1-es/"
    />
  )
}
